import {CalendarSettingsField} from "./CalendarSettingsField";
import allLocales from "@fullcalendar/core/locales-all";

// THESE ARE CONFIGURABLE VIA THE SETTINGS DIALOG BUT ARE NOT PART OF FULLCALENDAR.IO
export const CUSTOM_CONFIGURABLE_SETTINGS = {
    showThumbnailInEvent: false,
    showSwitchOffTimes: true,
}

export const CONFIGURABLE_SETTINGS = {
    initialView: 'timeGridWeek',
    slotDuration: '00:10:00',
    weekNumbers: true,
    nowIndicator: true,
    ...CUSTOM_CONFIGURABLE_SETTINGS
}

// We could also set it to the current time!
// const now = new Date();
// const scrollTime = `${now.getHours().toString().padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')}:00`;

/** @type{CalendarSettings} */
export const SETTINGS = {
    ...CONFIGURABLE_SETTINGS,
    // THESE COULD BE CONFIGURED BY THE DIALOG BUT ARNT YET
    weekends: true,
    scrollTime: '12:00:00',

    // THESE ARE DEFINED BY US
    locales: allLocales,
    locale: Laravel.activeLocale,
    aspectRatio: _.round((window.innerWidth * 0.6) / (window.innerHeight * 0.65), 1),
    navLinks: true,
    eventResizableFromStart: true,
    // expandRows: true,
    editable: true,
    // selectable: true, // allow clicks into the calendar
    selectMirror: true,
    dayMaxEvents: true,
    dayMaxEventRows: true,
    eventMaxStack: 1,
    droppable: true,
    eventOverlap: false,
    moreLinkClick: 'day',
}

export const VIEWS = [
    { name: 'dayGridMonth', translation: Lang.langGet('Month')},
    { name: 'timeGridWeek', translation: Lang.langGet('Week')},
    { name: 'timeGridDay', translation: Lang.langGet('Day')},
    { name: 'listWeek', translation: Lang.langGet('List')},
];

export const DURATIONS = [
    { name: '00:30:00', translation: `30 ${Lang.langGet('Minutes')}`},
    { name: '00:15:00', translation: `15 ${Lang.langGet('Minutes')}`},
    { name: '00:10:00', translation: `10 ${Lang.langGet('Minutes')}`},
    { name: '00:05:00', translation: `5 ${Lang.langGet('Minutes')}`},
    { name: '00:01:00', translation: `1 ${Lang.langGet('Minute')}`},
];

export const EXPIRY_TIMES = [
    { name: 'immediately', translation: Lang.langGet('Immediately')},
    { name: 'week', translation: Lang.langGet('One week')},
    { name: 'month', translation: Lang.langGet('One month')},
];

/** @type{Array<CalendarSettingsField>} */
export const SETTING_FIELDS = [
    CalendarSettingsField.createSelection('initialView', Lang.langGet('Initial View'), VIEWS),
    CalendarSettingsField.createSelection('slotDuration', Lang.langGet('Time Slot Duration'), DURATIONS),
    CalendarSettingsField.createCheckbox('nowIndicator', Lang.langGet('Show Current Time Indicator')),
    CalendarSettingsField.createCheckbox('weekNumbers', Lang.langGet('Show Week Numbers')),
    CalendarSettingsField.createCheckbox('showSwitchOffTimes', Lang.langGet('Show Switch-On Times')),
    CalendarSettingsField.createCheckbox('showThumbnailInEvent', Lang.langGet('Show Thumbnail In Event')),
];
